import { createContext } from 'react';

const LinkOptionContext = createContext();

export default LinkOptionContext;